import React from 'react'
import CxDetailscroll from '../../CommonUtils/CxDetailsScroll/CxDetailscroll'

const MessageA13s = (probs) => {
  return (
    <div>
      <CxDetailscroll {...probs}/>
    </div>
  )
}

export default MessageA13s
